import { ErrorCode } from '@afterpaytouch/portal-api'
import { CheckoutError, TerminalErrorCode, VerificationErrorCode, VerificationFlowContext } from '../../model'
import { Route } from '../../config/router'

export const getCheckoutError = (e: VerificationErrorCode): CheckoutError => {
  const key = VerificationErrorCode[e]
  const terminalError = key in TerminalErrorCode ? TerminalErrorCode[key as keyof typeof TerminalErrorCode] : TerminalErrorCode.MaxAttempts
  const errorCode = key in ErrorCode ? ErrorCode[key as keyof typeof ErrorCode] : ErrorCode.MaxAttemptsReached

  return {
    error: terminalError,
    errorCode,
  }
}

export const getBackRoute = (context: VerificationFlowContext): Route => {
  if (context === VerificationFlowContext.Registration) {
    return Route.SIGN_UP
  } else {
    return Route.ENTER_EMAIL
  }
}
